import { createSlice } from "@reduxjs/toolkit";
import {
  changePassword,
  deleteAccount,
  disableAccount,
  fetchfreelancerProfile,
  fetchOffers,
  fetchSubscriptionData,
  planCancel,
  fetchSubscriptions,
  fetchOpenTalentSubscriptions,
  freelancerSignUp,
  profileStep1Submit,
  profileStep2Submit,
  profileStep3Submit,
  profileStep4Submit,
  purchaseSubscription,
  freelancerUpdateProfile,
  fetchPostJobs,
  freelancerUpdateProfileStep,
  fetchFreelancerAvailability,
  raiseSupportTicket,
  fetchAllTickets,
  fetchOpenTalentJobs,
  applyOpenTalentJob,
  saveOpenTalentJob,
  fetchSavedOpenTalentJobs,
  fetchAppliedOpenTalentJobs,
  reviewOpenTalentJob,
  scheduleOpenTalentInterviewAction,
  fetchOpenTalentDashboard,
} from "../actions/authAction";
import { setProfile } from "../../../../utils/pip";

const initialState = {
  isLoading: false,
  subLoading: false,
  isFindAJobModal: false,
  registerStep: 1,
  freelancerProfileData: {},
  subscriptionList: [],
  offerList: [],
  freelancerSubscriptionPlan: [],
  freelancersJobs: [],
  openTalentJobs: [],
  savedJobs: [],
  appliedJobs: [],
  dashboardData: {},
  ticketList: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setRegisterStep: (state, action) => {
      state.registerStep = action.payload;
    },
    setIsFindAJobModal: (state, action) => {
      state.isFindAJobModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    // freelancer-sign-up
    builder.addCase(freelancerSignUp.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(freelancerSignUp.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(freelancerSignUp.rejected, (state, action) => {
      state.subLoading = false;
    });

    // fetch-subscription
    builder.addCase(fetchSubscriptions.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.subscriptionList = data ?? [];
      state.subLoading = false;
    });
    builder.addCase(fetchSubscriptions.rejected, (state, action) => {
      state.subLoading = false;
    });

    // fetch-open-talent-subscriptions
    builder.addCase(fetchOpenTalentSubscriptions.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchOpenTalentSubscriptions.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.subscriptionList = data?.subscriptions ?? [];
      state.subLoading = false;
    });
    builder.addCase(fetchOpenTalentSubscriptions.rejected, (state, action) => {
      state.subLoading = false;
    });

    // purchase-subscription
    builder.addCase(purchaseSubscription.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(purchaseSubscription.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(purchaseSubscription.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step1-submit
    builder.addCase(profileStep1Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep1Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep1Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step2-submit
    builder.addCase(profileStep2Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep2Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep2Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step3-submit
    builder.addCase(profileStep3Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep3Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep3Submit.rejected, (state, action) => {
      state.subLoading = false;
    });
    // profile-step4-submit
    builder.addCase(profileStep4Submit.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(profileStep4Submit.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(profileStep4Submit.rejected, (state, action) => {
      state.subLoading = false;
    });

    // fetch-freelancer-profile
    builder.addCase(fetchfreelancerProfile.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchfreelancerProfile.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.freelancerProfileData = data || {};
      state.subLoading = false;
    });
    builder.addCase(fetchfreelancerProfile.rejected, (state, action) => {
      state.subLoading = false;
    });
    // fetch-offers
    builder.addCase(fetchOffers.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.offerList = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.subLoading = false;
    });

    // change-password
    builder.addCase(changePassword.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.subLoading = false;
    });

    // account-disable
    builder.addCase(disableAccount.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(disableAccount.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(disableAccount.rejected, (state, action) => {
      state.subLoading = false;
    });

    // account-delete
    builder.addCase(deleteAccount.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteAccount.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchSubscriptionData
    builder.addCase(fetchSubscriptionData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSubscriptionData.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.freelancerSubscriptionPlan = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchSubscriptionData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // planCancel
    builder.addCase(planCancel.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(planCancel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(planCancel.rejected, (state, action) => {
      state.isLoading = false;
    });

    // freelancer-profile-update
    builder.addCase(freelancerUpdateProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(freelancerUpdateProfile.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(freelancerUpdateProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchPostJobs
    builder.addCase(fetchPostJobs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPostJobs.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.freelancersJobs = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchPostJobs.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchOpenTalentJobs
    builder.addCase(fetchOpenTalentJobs.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchOpenTalentJobs.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.openTalentJobs = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchOpenTalentJobs.rejected, (state) => {
      state.subLoading = false;
    });

    // freelancerUpdateProfileStep
    builder.addCase(freelancerUpdateProfileStep.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(freelancerUpdateProfileStep.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(freelancerUpdateProfileStep.rejected, (state, action) => {
      state.isLoading = false;
    });

    // raise-support-ticket
    builder.addCase(raiseSupportTicket.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(raiseSupportTicket.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(raiseSupportTicket.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-all-tickets
    builder.addCase(fetchAllTickets.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(fetchAllTickets.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.ticketList = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchAllTickets.rejected, (state, action) => {
      state.subLoading = false;
    });

    // apply-open-talent-job
    builder.addCase(applyOpenTalentJob.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(applyOpenTalentJob.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(applyOpenTalentJob.rejected, (state) => {
      state.isLoading = false;
    });

    // save-open-talent-job
    builder.addCase(saveOpenTalentJob.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(saveOpenTalentJob.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(saveOpenTalentJob.rejected, (state) => {
      state.isLoading = false;
    });

    // fetch-saved-open-talent-jobs
    builder.addCase(fetchSavedOpenTalentJobs.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchSavedOpenTalentJobs.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.savedJobs = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchSavedOpenTalentJobs.rejected, (state) => {
      state.subLoading = false;
    });

    // fetch-applied-open-talent-jobs
    builder.addCase(fetchAppliedOpenTalentJobs.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchAppliedOpenTalentJobs.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.appliedJobs = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchAppliedOpenTalentJobs.rejected, (state) => {
      state.subLoading = false;
    });

    // review-open-talent-job
    builder.addCase(reviewOpenTalentJob.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(reviewOpenTalentJob.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(reviewOpenTalentJob.rejected, (state) => {
      state.isLoading = false;
    });

    // fetch-open-talent-dashboard
    builder.addCase(fetchOpenTalentDashboard.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchOpenTalentDashboard.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.dashboardData = data || {};
      state.subLoading = false;
    });
    builder.addCase(fetchOpenTalentDashboard.rejected, (state) => {
      state.subLoading = false;
    });

    // schedule-open-talent-interview-action
    builder.addCase(scheduleOpenTalentInterviewAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(scheduleOpenTalentInterviewAction.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(scheduleOpenTalentInterviewAction.rejected, (state) => {
      state.isLoading = false;
    });

    // fetchFreelancerAvailability
    // builder.addCase(fetchFreelancerAvailability.pending, (state, action) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(fetchFreelancerAvailability.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(fetchFreelancerAvailability.rejected, (state, action) => {
    //   state.isLoading = false;
    // });
  },
});

export default authSlice.reducer;
export const { setRegisterStep, setIsFindAJobModal } = authSlice.actions;
